import { getFileName } from "@helpers/getFileName"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { endpoints, SeempActionGroup } from "api"

type SeempGetReportsQueryArgs = {
	plantId: number | undefined
}

export const getUseSeempGetActionsForVesselqueryKey = (
	plantId: number | undefined,
	source?: string
) => {
	return [
		`source=${source ?? getFileName()}`,
		`queryId=SeempGetActionsForVessel`,
		`endpoints=[${endpoints.seempGetActionGroupsForPlant.getName()}]`,
		`plantId=${plantId}`,
	]
}

export function useSeempGetActionsForVesselQuery(args: SeempGetReportsQueryArgs) {
	const enabled = args.plantId !== undefined

	const res = useQuery({
		queryKey: getUseSeempGetActionsForVesselqueryKey(args.plantId, getFileName()),
		queryFn: async (): Promise<SeempActionGroup[] | null> => {
			if (args.plantId === undefined) {
				throw new Error("useSeempGetActionsForVesselQuery requires a plantId parameter")
			}

			const seempActionGroups = await requestApi2(endpoints.seempGetActionGroupsForPlant, {
				plantId: args.plantId,
			})
			return seempActionGroups
		},
		enabled,
		staleTime: 600000,
		refetchInterval: 600000,
	})
	return res
}
